import { ApprovalMessageController } from './approval-message.controller'

function approvalMessage () {
  return {
    restrict: 'E',
    scope: {
      user: '<',
      status: '<',
      asset: '<',
      task: '<',
      showSeeAttachment: '<',
      updatedAt: '<',
      isPrivate: '<'
    },
    templateUrl: '/core/directives/approval-message/approval-message.html?$$REVISION$$',
    controller: ApprovalMessageController
  }
}

export { approvalMessage }
